import {
    START_PAYMENT_TRANSACTION_LOADING, START_PAYMENT_TRANSACTION_SUCCESS,
    START_PAYMENT_TRANSACTION_ERROR, RESET_PAYMENT_TRANSACTION
} from "../actions/actionPaymentTransaction";

const initialState = {
    Payment: {},
    loading: false,
    PaymentInfoError: ''
};

function reducerPaymentTransaction(state = initialState, action) {
    switch (action.type) {
        case START_PAYMENT_TRANSACTION_LOADING: {
            return {
                ...state,
                loading: true,
                Payment: {},
                PaymentInfoError: ''
            };
        }
        case START_PAYMENT_TRANSACTION_SUCCESS: {
            return {
                ...state,
                loading: false,
                Payment: action.payload[0],
                PaymentInfoError: ''
            };
        }
        case START_PAYMENT_TRANSACTION_ERROR: {

            let error = "";
            if (action.error.Errors) {
                error = action.error.Errors[0].ErrorMessage
            }
            else
                error = action.error.message;

            return {
                ...state,
                loading: false,
                Payment: {},
                PaymentInfoError: error
            }
        }
        case RESET_PAYMENT_TRANSACTION: {
            return {
                ...state,
                loading: false,
                Payment: {},
                PaymentInfoError: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerPaymentTransaction;